module.exports = __webpack_public_path__ + "static/media/golfer-7-b.c46b3d1e.png";